import "../../css/style.css";
import React from "react";
import ChargeBeeImage from "../../media/chargebee.webp";
import DartImage from "../../media/dart.webp";
import FlutterImage from "../../media/flutter.webp";
import FirebaseImage from "../../media/firebase.webp";
import RiverpodImage from "../../media/riverpod.webp";

function Hero() {
  return (
    <>
      <section id="home" className="hero">
        <div className="container">
          <div className="content">
            <div className="hero-main">
              <div className="hero-text">
                <h1>Flutter Developer</h1>
                <p>
                  Hi, I'm Jitendra Purohit. A passionate Flutter Developer based
                  in India.
                </p>
                <span>
                  <a
                    aria-label="linkedin"
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.linkedin.com/in/stefan-topalovic-dev/"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a
                    aria-label="github"
                    rel="noreferrer"
                    target="_blank"
                    href="https://github.com/stefvndev"
                  >
                    <i className="fa-brands fa-github"></i>
                  </a>
                </span>
              </div>

              <div className="hero-img"></div>
            </div>

            {/*  */}
            <div className="skills">
              <p>Tech Stack</p>
              <div className="logos">
                <ul>
                  <li>
                    <img src={FlutterImage} title="Flutter" alt="program_img" />
                  </li>
                  <li>
                    <img src={DartImage} title="Dart" alt="program_img" />
                  </li>
                  <li>
                    <img
                      src={RiverpodImage}
                      title="Riverpod"
                      alt="program_img"
                    />
                  </li>
                  <li>
                    <img
                      src={FirebaseImage}
                      title="Firebase"
                      alt="program_img"
                    />
                  </li>
                  <li>
                    <img
                      src={ChargeBeeImage}
                      title="Chargebee"
                      alt="program_img"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;
